module.exports = __webpack_public_path__ + "img/KEC-inside-blued.b55e5798.png";